/*
 * Voyado Recently Viewed controller.
 * ----------------------------------
 * Thin per-surface controller: lifecycle + one VoyadoCarousel.attach call whose
 * opts.fetch reads VoyadoClient.autocomplete()'s recentlyViewed list (same colour
 * group shape as the recommendation panels) and drops the current product on a
 * PDP via data-product-handle. The scroll engine, slide wrapper, cards-rendered
 * dispatch and controls mirror all live in the shared assets/voyado-carousel.js.
 *
 * User based (no productKey, no algorithm) — works on product, home and collection
 * templates. Loaded section-scoped + URL-deduped (type=module).
 */
;(function () {
  'use strict';

  var SELECTOR = '[data-voyado-recently-viewed]';
  var attached = new WeakSet();

  function attach(section) {
    if (attached.has(section) || !window.VoyadoCarousel) return;
    attached.add(section);

    var productHandle = section.getAttribute('data-product-handle') || '';
    var rawLimit = parseInt(section.getAttribute('data-recommendation-limit'), 10);
    var limit = rawLimit > 0 ? Math.min(20, rawLimit) : 12;

    // Drop the product the visitor is currently on (PDP only — empty elsewhere).
    function sameProduct(p) {
      if (!productHandle) return false;
      var link = (p && p.link) || '';
      var seg = link.split('?')[0].replace(/\/+$/, '').split('/').pop();
      return seg === productHandle;
    }

    window.VoyadoCarousel.attach(section, {
      trigger: 'intersection',
      fetch: function () {
        if (!window.VoyadoClient || !window.VoyadoClient.autocomplete) {
          return Promise.reject(new Error('voyado-recently-viewed: no client'));
        }
        // Recently viewed rides the autocomplete response. presentCustom matches the
        // other cards so the swatch image + badges come through.
        return window.VoyadoClient.autocomplete(
          { presentCustom: 'swatch_image_url|product_badges|colour_name' }, {}
        ).then(function (res) {
          return ((res && res.recentlyViewed) || [])
            .map(function (g) { return (g && g.products) || []; })
            .filter(function (ps) { return ps.length && !sameProduct(ps[0]); })
            .slice(0, limit);
        });
      }
    });
  }

  function initAll(root) {
    var r = root || document;
    var nodes = r.querySelectorAll ? r.querySelectorAll(SELECTOR) : [];
    nodes.forEach(attach);
  }

  function teardown(root) {
    if (!root || !root.querySelectorAll || !window.VoyadoCarousel) return;
    root.querySelectorAll(SELECTOR).forEach(function (section) {
      window.VoyadoCarousel.detach(section);
      attached.delete(section);
    });
  }

  if (document.readyState === 'complete') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
